import(/* webpackMode: "eager" */ "/Users/sauldeleon/Projects/mine/portfolio-blog/apps/web/app/[lng]/(home)/layout.next.tsx")